export enum InstanceStatusCodes {
    PTC = 'PTC',
    PTU = 'PTU',
    RDY = 'RDY',
    PTD = 'PTD',
    MM = 'MM'
}
